import { render, staticRenderFns } from "./Bmjl.vue?vue&type=template&id=02f7889b&scoped=true"
import script from "./Bmjl.vue?vue&type=script&lang=js"
export * from "./Bmjl.vue?vue&type=script&lang=js"
import style0 from "./Bmjl.vue?vue&type=style&index=0&id=02f7889b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f7889b",
  null
  
)

export default component.exports